import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'corrective-action';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Corrective Action',
};

const correctiveAction = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { correctiveAction };
